

/**
 * 挖方体积计算
 */

import DrawPolygon from "../plot/DrawPolygon"
import ConstantDraw from "../constants/ConstantDraw"
import { formatNum } from "./utils/space"
import { interPolygon, getAreaOfTriangle } from "./utils/index"
class ExcavationCalc extends DrawPolygon {

    constructor(options) {
        super(options);
        this.options = options;
        this.sum = 0;
        this.entitiesLabel = [];
        this.centerPos = undefined;
    }

    initEditor() {
    }

    leftClick(evt) {
        super.leftClick(evt); //调用
        var $this = this;
        var l = $this.positions.length;
        var p = this.createPoint($this.positions[l-1], ConstantDraw.Style_KeyPos);
        this.entitiesLabel.push(p);
    }
    rightClick(evt){
        var $this = this;
        var l = $this.positions.length;
        var end = $this.positions[l - 1];
        var p = this.createPoint(end, ConstantDraw.Style_KeyPos);
        this.entitiesLabel.push(p);
        super.rightClick(evt); //调用
    }

    reset() {
        super.reset();
        this.entitiesLabel = [];
    }
    clear(){
        super.clear();
        for (var i = 0; i < this.entitiesLabel.length; i++) {
            this.viewer.entities.remove(this.entitiesLabel[i]);
        }
    }
    initCenterPoint() {
        var keyPos = this.positions; //拿到关键点数组
        var posArr = this.cart2Wgs84(keyPos);
        var center = this.getCenter(posArr);
        var cart = Cesium.Cartesian3.fromDegrees(center[0], center[1]);
        this.centerPos = this.createPoint(cart);
        this.entities.push(this.centerPos);
    }
    leftDoubleClick(evt) {
        this.options.analysisStart();
        this.initCenterPoint();
        super.leftDoubleClick(evt);
        this.computeVolume();
    }
    computeVolume() {

        var p = this.centerPos//实体
        var lable = ConstantDraw.Style_Label;
        var $this = this;
        interPolygon({
            positions: this.positions,
            scene: this.viewer.scene,
            splitNum: 15,
            has3dtiles: false,
            asyn: true,
            calback: function (resultInter) {

                var res = $this.updateVolumeByMinHeight(resultInter);
                lable.text = `挖方体积:${formatNum(res.totalVolume)}立方米`
                p.label = lable;
                $this.options.analysisDone();
            }
        });
    }

    //根据 最低底面高度 重新计算填挖方体积 
    updateVolumeByMinHeight(resultInter) {
        var minHeight = resultInter.minHeight;

        var totalArea = 0; //总面积(横截面/投影底面)
        var totalVolume = 0; //总体积

        for (var i = 0, len = resultInter.list.length; i < len; i++) {
            var item = resultInter.list[i];

            var pt1 = item.point1;
            var pt2 = item.point2;
            var pt3 = item.point3;

            //横截面面积 
            var bottomArea = getAreaOfTriangle(pt1.point, pt2.point, pt3.point);
            item.area = bottomArea;
            totalArea += bottomArea;

            var height1 = pt1.height;
            var height2 = pt2.height;
            var height3 = pt3.height;
            if (height1 < minHeight) height1 = minHeight;
            if (height2 < minHeight) height2 = minHeight;
            if (height3 < minHeight) height3 = minHeight;

            var h = (height1 + height2 + height3) / 3 - minHeight; //高度
            
            // console.log('高度',h);
            // console.log('底面积',bottomArea);
            // console.log('最低点高度',minHeight);
            //挖方体积 （横截面面积 * 3个点的平均高） 
            var cutVolume = bottomArea * h;
            item.cutVolume = cutVolume;
            totalVolume = totalVolume + cutVolume;
        }

        resultInter.totalArea = totalArea; //总面积(横截面/投影底面)
        resultInter.totalVolume = totalVolume; //总体积
        return resultInter;
    }

    cart2Wgs84(cartesain3Array) {
        let cartographics = Cesium.Ellipsoid.WGS84.cartesianArrayToCartographicArray(cartesain3Array);
        return cartographics.map(carto => {
            return [Cesium.Math.toDegrees(carto.longitude), Cesium.Math.toDegrees(carto.latitude)]
        })
    }

    //获取中心点
    getCenter(arr) {
        let centerLonLat = []
        if (arr.length) {
            const lon = []
            const lat = []
            const poly = [];
            for (let i = 0, len = arr.length; i < len; i++) {
                lon.push(arr[i][0])
                lat.push(arr[i][1])
            }
            for (let i = 0, len = lon.length; i < len; i++) {
                poly.push({
                    x: parseFloat(lon[i]),
                    y: parseFloat(lat[i]),
                    z: 0
                });
            }
            const sortedLongitudeArray = poly.map(item => item.x).sort();
            const sortedLatitudeArray = poly.map(item => item.y).sort();
            const centerLongitude = ((parseFloat(sortedLongitudeArray[0]) + parseFloat(sortedLongitudeArray[sortedLongitudeArray.length - 1])) / 2).toFixed(14);
            const centerLatitude = ((parseFloat(sortedLatitudeArray[0]) + parseFloat(sortedLatitudeArray[sortedLatitudeArray.length - 1])) / 2).toFixed(14);
            centerLonLat = [Number(centerLongitude), Number(centerLatitude)]
        }
        return centerLonLat;
    }

}

export default ExcavationCalc